import { render, staticRenderFns } from "./CardSendEmail.vue?vue&type=template&id=484a3628"
import script from "./CardSendEmail.vue?vue&type=script&lang=js"
export * from "./CardSendEmail.vue?vue&type=script&lang=js"
import style0 from "./CardSendEmail.vue?vue&type=style&index=0&id=484a3628&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('484a3628')) {
      api.createRecord('484a3628', component.options)
    } else {
      api.reload('484a3628', component.options)
    }
    module.hot.accept("./CardSendEmail.vue?vue&type=template&id=484a3628", function () {
      api.rerender('484a3628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/identifiers/components/CardSendEmail.vue"
export default component.exports